import { Component, inject, Injector, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RaLoadingComponent, RaToastService } from '@shared/components';
import { UserController } from 'src/app/domain/controllers/user.controller';

@Component({
    selector: 'delete-account',
    templateUrl: './delete-account.html',
    styleUrl: './delete-account.scss',
    imports: [ReactiveFormsModule, MatInputModule, RaLoadingComponent, TranslatePipe],
})
export class DeleteAccountPage implements OnInit {
    public form: FormGroup;
    public loading: boolean;

    //* Injects
    private _injector = inject(Injector);
    private _raToastService = inject(RaToastService);
    private _userController = inject(UserController);

    ngOnInit(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.form = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email]),
            password: new FormControl('', [Validators.required]),
        });
    }

    public removeAccount(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            const translate = this._injector.get(TranslateService);
            this._raToastService.error({
                message: translate.instant('deleteAccount.formInvalidToast'),
            });
            return;
        }

        this.loading = true;
        const email = this.form.get('email').value;
        const password = this.form.get('password').value;

        this._userController.deleteByEmail(email, password).subscribe({
            next: () => (this.loading = false),
            error: () => (this.loading = false),
        });
    }
}
